import { useMatch } from '@xing-com/crate-core-router';
import { XING_JOBS_SEARCH_KI_PATH } from '@xing-com/crate-core-routes';

export const useIsAiSearch = (): boolean => {
  const isAiSearchUrl = !!useMatch(XING_JOBS_SEARCH_KI_PATH);

  return isAiSearchUrl;
};
